export default __webpack_public_path__ + "static/media/blog-post.3.bdef2d7b.md";